export const application = 'bright-academy-preprod';

export const apiURL = '/bright/api';

export const gaId = 'UA-91016801-4';

export const wsURL = 'https://app-preprod.learnwithbright.com';

export const rootUrl = 'https://admin-preprod.learnwithbright.academy';

export const academyURL = 'https://app-preprod.learnwithbright.academy';
